import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import {
  Box,
  Checkbox,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { SelectField, SelectInput, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import PaperComponent from "../../unit/PaperComponent";
import useNotify from "../../unit/useNotify";
// import { set } from "lodash";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import { fontWeight } from "@mui/system";

type BankAccountRow = {
  bankAccountId: string;
  bankAccountStatus?: string;
  sStatus?: string;
  sInstitutionName?: string;
  sAccountType?: string;
  sRoutingNumber?: string;
  sAccountNumber?: string;
};

interface NormalizedAccount {
  bankAccountId: string;
  bankAccountStatus: any;
  sInstitutionName: any;
  sAccountType: any;
  sRoutingNumber: any;
  sAccountNumber: any;
}
const CustomPaymentRefundDialog = ({ ...props }) => {
  const { successNotify, errorNotify } = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [refundType, setRefundType] = React.useState("");
  const [psDate, setPsDate] = React.useState("");
  const [addLateFee, setAddLateFee] = React.useState("no");
  const [isCheckingEligibility, setIsCheckingEligibility] =
    React.useState(false);
  const [isEligible, setIsEligible] = React.useState(true);
  const [eligibilityMessage, setEligibilityMessage] = React.useState("");
  const [ineligibleReasons, setIneligibleReasons] = React.useState<string[]>(
    []
  );
  const [bankAccountRows, setBankAccountRows] = React.useState<
    BankAccountRow[]
  >([]);
  const [initiateTransferDate, setInitiateTransferDate] = React.useState(
    new Date().toISOString().split("T")[0]
  );
  const [transferBankAccount, setTransferBankAccount] = React.useState("");
  const [customerAccount, setCustomerAccount] = React.useState("");
  const [customerAccountRows, setCustomerAccountRows] = React.useState<
    NormalizedAccount[]
  >([]);
  const [notes, setNotes] = React.useState("");
  const [missingFieldKeys, setMissingFieldKeys] = React.useState<string[]>([]);

  const paymentId = props?.paymentId;
  const appId = props?.appId;
  // const data = props?.data;
  const todayStr = new Date().toISOString().split("T")[0];

  //   const defaultIneligibleReasons = [
  //     "There is no payment source available for receiving ACH refund",
  //     "The most recent ACH payment was made 30 days earlier",
  //   ];

  const normalizeBankAccounts = (accountList: any): BankAccountRow[] => {
    return Object.values(accountList).map((item: any) => ({
      bankAccountId: String(item.bankAccountId),
      bankAccountStatus: item.bankAccountStatus,
      sStatus: item.sStatus,
      sInstitutionName: item.sInstitutionName,
      sAccountType: item.sAccountType,
      sRoutingNumber: item.sRoutingNumber,
      sAccountNumber: item.sAccountNumber,
    }));
  };

  const normalizeCustomerAccount = (
    searchCustomerAccount: any
  ): NormalizedAccount[] => {
    if (!searchCustomerAccount) {
      return [];
    }
    return Object.values(searchCustomerAccount).map((item: any) => ({
      // bankAccountId: String(item?.iAccountId),
      bankAccountId: String(item?.id),
      bankAccountStatus: item?.sStatus,
      sInstitutionName: item?.sInstitutionName,
      sAccountType: item?.sAccountType,
      sRoutingNumber: item?.sRoutingNumber,
      sAccountNumber: item?.sAccountNumber,
    }));
  };
  const getBankAccountStatusText = (item: BankAccountRow) => {
    if (item.bankAccountStatus === "USED") {
      return `Used${item.sStatus ? ` (${item.sStatus})` : ""}`;
    }
    if (item.bankAccountStatus === "DISABLED") {
      return "Disabled";
    }
    if (item.bankAccountStatus === "ACTIVE") {
      return "Active";
    }
    return item.bankAccountStatus || "";
  };

  const checkRefundEligibility = async () => {
    if (!appId || !paymentId) {
      setIsEligible(false);
      setEligibilityMessage("Missing appId or paymentId");
      return;
    }

    setIsCheckingEligibility(true);
    setIsEligible(true);
    setEligibilityMessage("");
    setIneligibleReasons([]);

    const checkUrl = "loans/payment/refund/check";
    const responseBack = await sendRequest(checkUrl, {
      id: appId,
      data: {
        appId,
        paymentId,
      },
    });

    const responseData = responseBack?.data || {};
    const responseCode = responseBack?.code;
    // const eligibleFromResponse = responseBack?.data?.noPaymentError;
    const eligibleFromResponse = [];
    const codeOk = responseCode == "200" || responseCode == 200;
    const finalEligible = codeOk && eligibleFromResponse?.length == 0;

    const bankAccountList = responseData?.newBankAccountDataData || [];
    const normalizedAccounts = normalizeBankAccounts(bankAccountList);
    // console.log("normalizedAccounts===========>>>", normalizedAccounts);
    setBankAccountRows(normalizedAccounts);

    const customerAccountFromResponse = normalizeCustomerAccount(
      responseData?.searchCustomerAccount
    );
    setCustomerAccountRows(customerAccountFromResponse || []);
    if (customerAccountFromResponse.length > 0) {
      setCustomerAccount(customerAccountFromResponse[0].bankAccountId);
    } else {
      setCustomerAccount("");
    }

    if (normalizedAccounts.length > 0) {
      setTransferBankAccount(normalizedAccounts[0].bankAccountId);
    }
    if (responseBack?.code == 201 && responseBack?.message) {
      setIsEligible(false);
      setEligibilityMessage(
        "The payments associated with this loan are not eligible for refunds for one or more of the following reasons:"
      );
      setIneligibleReasons([responseBack?.message]); // Clear ineligible reasons if message is provided
      //   return;
    }
    if (!finalEligible) {
      setIsEligible(false);
      setEligibilityMessage(
        "The payments associated with this loan are not eligible for refunds for one or more of the following reasons:"
      );
      const reasons = responseBack?.data?.noPaymentError;
      if (reasons) {
        setIneligibleReasons(
          Array.isArray(reasons) && reasons.length > 0 ? reasons : []
        );
      }
    } else {
      setIsEligible(true);
    }
    setIsEligible(true);
    setIsCheckingEligibility(false);
  };

  const handleClickOpen = async () => {
    setOpen(true);
    await checkRefundEligibility();
  };

  const handleClose = () => {
    setOpen(false);
    setMissingFieldKeys([]);
  };

  const clearMissingField = (key: string) => {
    setMissingFieldKeys((prev) => prev.filter((item) => item !== key));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!appId || !paymentId) {
      errorNotify("Missing appId or paymentId");
      return;
    }
    if (!isEligible) {
      errorNotify("Current payment is not eligible for refund");
      return;
    }
    if (initiateTransferDate < todayStr) {
      errorNotify("Set Date to Initiate Transfer cannot be earlier than today");
      return;
    }

    setIsLoading(true);

    const reqUrl = "loans/payment/refund";
    let requestData: any = {
      paymentId: paymentId,
      amount: props?.amount,
      applicationId: appId,
      initiate_transfer_date: initiateTransferDate,
      accountId: transferBankAccount,
      userAccountId: customerAccount,
      paymentnotes: notes,
      // paymentData: data,
      paymentData: [],
      // addlatefee: addLateFee,
      //这个是payment refund， actionForm = 空， 后台会判断是否是paid-off
      actionFrom: "",
      //ps_date, refundType 是针对如何处理当前这笔payment， 经讨论去掉，让用户在modify里进行设置,所以这里传入固定值
      ps_date: refundType === "reschedule" ? psDate : "",
      refundType: "keep",
    };
    const requiredFields = [
      { key: "paymentId", label: "Payment ID" },
      { key: "applicationId", label: "Application ID" },
      {
        key: "initiate_transfer_date",
        label: "Set Date to Initiate Transfer",
      },
      { key: "accountId", label: "Bank Account" },
      { key: "userAccountId", label: "Customer Account" },
      // { key: "refundType", label: "Cancel Reason" },
    ];
    const missingFields = requiredFields.filter(
      (field) => !requestData[field.key]
    );

    if (missingFields.length > 0) {
      setMissingFieldKeys(missingFields.map((field) => field.key));
      errorNotify(
        `Missing required fields: ${missingFields
          .map((field) => field.label)
          .join(", ")}`
      );
      setIsLoading(false);
      return;
    }
    setMissingFieldKeys([]);
    // console.log("requestData to submit: ", requestData);
    const responseBack = await sendRequest(reqUrl, {
      id: appId,
      data: requestData,
    });

    if (responseBack && responseBack.code == "200") {
      successNotify("Payment refund submitted successfully");
      handleClose();
      refresh();
    } else {
      errorNotify(responseBack?.message || "Payment refund failed");
    }

    setIsLoading(false);
  };

  return (
    <>
      <Tooltip title="Refund Payment" placement="left">
        <SettingsBackupRestoreIcon
          color="error"
          onClick={handleClickOpen}
          sx={{
            ml: 1,
            fontSize: "1.2rem",
            verticalAlign: "middle",
            cursor: "pointer",
            ...props?.sx,
          }}
        />
      </Tooltip>

      <Dialog
        id={`dialog-payment-refund-${appId}-${paymentId}`}
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: handleSubmit,
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title="Payment Refund" />
        </DialogTitle>
        <DialogContent>
          {isCheckingEligibility && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
              }}
            >
              <CircularProgress size={18} />
              <Typography variant="body2">
                Checking refund eligibility...
              </Typography>
            </Box>
          )}

          {!isCheckingEligibility && !isEligible && (
            <DialogContentText sx={{ mb: 2 }}>
              {eligibilityMessage ||
                "The payments associated with this loan are not eligible for refunds for one or more of the following reasons:"}
              <ul>
                {(ineligibleReasons.length > 0 ? ineligibleReasons : []).map(
                  (reason, index) => (
                    <li key={index}>{reason}</li>
                  )
                )}
              </ul>
            </DialogContentText>
          )}

          {!isCheckingEligibility && isEligible && (
            <DialogContentText sx={{ mb: 2, color: "red" }}>
              Please note no ACH transaction involving the borrower's
              destination account, such as repayment or refund, can be initiated
              while an ACH refund is in process. The borrower cannot initiate an
              ACH payment until the ACH refund transfer has settled.
            </DialogContentText>
          )}
          {!isCheckingEligibility && (
            <>
              {isEligible && (
                <>
                  <div>
                    <HeaderLabelTitle
                      title="Select Rationale for Refund"
                      align="left"
                    />
                  </div>
                  <Box
                    id="bank-account-rows"
                    sx={{
                      mb: 0,
                      mt: 2,
                      color: "grey",
                      p: 1,
                      border: "1px solid",
                      borderRadius: 1,
                      borderColor: missingFieldKeys.includes("accountId")
                        ? "error.main"
                        : "transparent",
                    }}
                  >
                    <HeaderLabelTitle
                      title="Select Sending Account for Refund Transfer"
                      align="left"
                      sx={{ color: "grey", fontWeight: "normal" }}
                    />
                    {bankAccountRows.map((item) => (
                      <Box
                        key={`refund-bank-${item.bankAccountId}`}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        <Checkbox
                          checked={transferBankAccount === item.bankAccountId}
                          onChange={() => {
                            setTransferBankAccount(item.bankAccountId);
                            clearMissingField("accountId");
                          }}
                          value={item.bankAccountId}
                        />
                        <Box>
                          <Typography variant="body2">
                            <strong> [{getBankAccountStatusText(item)}]</strong>
                            &nbsp;&nbsp;
                            {item?.sInstitutionName} - {item?.sAccountType} ****
                            {item?.sAccountNumber?.slice(-4)}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                      <Checkbox
                        checked={transferBankAccount === "dwolla_balance"}
                        onChange={() => {
                          setTransferBankAccount("dwolla_balance");
                          clearMissingField("accountId");
                        }}
                        value="dwolla_balance"
                      />
                      <Box>
                        <Typography variant="body2">Dwolla Balance</Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    id="customer-account-rows"
                    sx={{
                      mb: 1,
                      p: 1,
                      border: "1px solid",
                      borderRadius: 1,
                      borderColor: missingFieldKeys.includes("userAccountId")
                        ? "error.main"
                        : "transparent",
                    }}
                  >
                    <HeaderLabelTitle
                      title="Select Receiving Account for Refund Transfer"
                      align="left"
                      sx={{ color: "grey", fontWeight: "normal" }}
                    />
                    {customerAccountRows.map((item) => (
                      <Box
                        key={`refund-customer-${item.bankAccountId}`}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        <Checkbox
                          checked={customerAccount === item.bankAccountId}
                          onChange={() => {
                            setCustomerAccount(item.bankAccountId);
                            clearMissingField("userAccountId");
                          }}
                          value={item.bankAccountId}
                        />
                        <Box>
                          <Typography variant="body2">
                            <strong> [{getBankAccountStatusText(item)}]</strong>
                            &nbsp;&nbsp;
                            {item?.sInstitutionName} - {item?.sAccountType} ****
                            {item?.sAccountNumber?.slice(-4)}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </>
              )}

              {isEligible && (
                <>
                  <Box
                    id="refund-rows"
                    sx={{
                      mb: 2,
                      p: 1,
                      pl: 0,
                      border: "1px solid",
                      borderRadius: 1,
                      borderColor: missingFieldKeys.includes("accountId")
                        ? "error.main"
                        : "transparent",
                    }}
                  >
                    <HeaderLabelTitle title="Set Refund Terms" align="left" />
                    <TextField
                      id="setDateToInitiateTransfer"
                      name="setDateToInitiateTransfer"
                      label="Set Date to Initiate Transfer"
                      type="date"
                      fullWidth
                      variant="outlined"
                      sx={{ mb: 2, mt: 2, ml: 1 }}
                      value={initiateTransferDate}
                      onChange={(e) => {
                        setInitiateTransferDate(e.target.value);
                        clearMissingField("initiate_transfer_date");
                      }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: todayStr }}
                      error={missingFieldKeys.includes(
                        "initiate_transfer_date"
                      )}
                      required
                    />
                    {/* <SelectInput
                    label="Cancel Reason"
                    source="refundType"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      mb: 0,
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: missingFieldKeys.includes("refundType")
                          ? "error.main"
                          : undefined,
                        borderWidth: missingFieldKeys.includes("refundType")
                          ? 2
                          : undefined,
                      },
                    }}
                    choices={[
                      { id: "keep", name: "Keep this payment" },
                      {
                        id: "reschedule",
                        name: "Reschedule this Payment to a future date before the next payment due date",
                      },
                      {
                        id: "postpone",
                        name: "Postpone this payment and add it to the next payment due date",
                      },
                      {
                        id: "skip",
                        name: "Skip this payment and extend all future payments by 1 payment period",
                      },
                    ]}
                    onChange={(e) => {
                      setRefundType(e.target.value);
                      clearMissingField("refundType");
                    }}
                  /> */}
                    {/* //如果选择reschedule， 则显示ps_date field, 否则不显示ps_date,
                  ps_date = '' */}
                    {/* {refundType === "reschedule" && (
                    <TextField
                      id="ps_date"
                      name="ps_date"
                      label="Payment Date"
                      type="date"
                      fullWidth
                      variant="outlined"
                      sx={{ mb: 0 }}
                      //   value={psDate}
                      onChange={(e) => setPsDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: todayStr }}
                      required={refundType === "reschedule"}
                    />
                  )} 
                    <SelectInput
                      label="Add Late Fee"
                      source="addLateFee"
                      choices={[
                        { id: "yes", name: "Yes" },
                        { id: "no", name: "No" },
                      ]}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      value={addLateFee}
                      onChange={(value) => setAddLateFee(String(value ?? ""))}
                      sx={{ mb: 0, ml: 1 }}
                    />
*/}
                    <TextField
                      id="notes"
                      name="notes"
                      label="Notes"
                      placeholder="Notes"
                      InputLabelProps={{ shrink: true }}
                      multiline={true}
                      minRows={3}
                      fullWidth
                      variant="outlined"
                      inputProps={{ maxLength: 150 }}
                      value={notes}
                      sx={{ mb: 0, ml: 1 }}
                      onChange={(e) => setNotes(e.target.value)}
                    />
                  </Box>
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            label={isLoading ? "loading" : "Confirm"}
            disabled={isLoading || isCheckingEligibility || !isEligible}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomPaymentRefundDialog;
